import React, { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsMergePopupActive,
  setStreamVideoResponse,
} from "../../../store/publicStore/actions/utilsActions/utilsActions";
import {
  checkContentMergeStatus,
  checkContentMergeStatusReset,
} from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/checkContentMergeStatusActions";
import { useToast } from "../../../hooks/useToast";
import {
  streamVideo,
  streamVideoReset,
} from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/streamVideoActions";
import { Oval } from "react-loader-spinner";
import { useNavigate } from "react-router";

const MergePopup = () => {
  const dispatch = useDispatch();
  const Toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [isFail, setIsFail] = useState(false);

  const navigate = useNavigate();

  const { isMergePopupActive, optAndSubmitContentResponse, participatedCampaignDetails } = useSelector(
    (state) => state.utilReducers
  );

  useEffect(() => {
    let interval; // Declare interval reference outside

    if (optAndSubmitContentResponse?.contentId) {
      setIsLoading(true);

      const checkStatus = () => {
        dispatch(
          checkContentMergeStatus(
            { contentId: optAndSubmitContentResponse?.contentId },
            (status, response, message) => {
              console.log("checkContentMergeStatus status:", status);

              if (status === 202) {
                return; // Keep the interval running
              }

              console.log("checkContentMergeStatus message:", message);

              clearInterval(interval); // Clear interval on any other status

              if (status === 200) {
                setTimeout(() => {
                  dispatch(
                    streamVideo(
                      {
                        s3ContentPath: optAndSubmitContentResponse?.contentPath,
                      },
                      (status, response, message) => {
                        if (status === 200) {
                          dispatch(setStreamVideoResponse(response));
                          setIsLoading(false);
                          dispatch(checkContentMergeStatusReset());
                          dispatch(streamVideoReset());
                        } else if (status) {
                          // Toast(message, "error");
                          dispatch(checkContentMergeStatusReset());
                          dispatch(streamVideoReset());
                          setIsLoading(false);
                        }
                      }
                    )
                  );
                }, 5000);
                setIsFail(false);
                return;
              } else if (status === 302) {
                dispatch(checkContentMergeStatusReset());
                setIsLoading(false);
                setIsFail(true);
                // Toast(message, "error");
              } else if (status !== 202) {
                // Toast(message, "error");
                dispatch(checkContentMergeStatusReset());
                setIsLoading(false);
                setIsFail(true);
              }
            }
          )
        );
      };

      interval = setInterval(checkStatus, 10000);

      // Cleanup interval on component unmount
      return () => clearInterval(interval);
    }
  }, [optAndSubmitContentResponse, isMergePopupActive]);

  console.log("isMergePopupActive :", isMergePopupActive);

  return (
    isMergePopupActive && (
      <div
        id="popup-overlay"
        className="fixed bottom-[2rem] right-[2rem] left-[2rem] sm:left-auto flex items-center justify-center z-50 w-auto sm:w-[20rem] md:w-[25rem] lg:w-[28rem] mx-auto"
      >
        <div
          className={`bg-white rounded-lg shadow-lg p-[2rem] sm:p-[2.5rem] w-full max-w-[80%] sm:max-w-[20rem] md:max-w-[25rem] lg:max-w-[28rem] relative border-2 border-[#0D9B50]`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between mb-[1rem] gap-2">
            <h2 className={` ${isFail && !isLoading ? 'text-red-500' : 'text-[#202224]'} text-[1.6rem] sm:text-[2rem] font-semibold break-words leading-snug`}>
              {isLoading ? "Merge in Progress..." : isFail ? "Merge Failed" : "Merge Completed"}
            </h2>
            {!isLoading && (
              <button
                onClick={() => { dispatch(setIsMergePopupActive(false)); setIsFail(false) }}
                className="text-gray-500 hover:text-gray-700"
              >
                <RxCross1 size={22} />
              </button>
            )}
            {isLoading && (
              <Oval
                visible={true}
                height="25"
                width="25"
                color="#000000"
                ariaLabel="oval-loading"
              />
            )}
          </div>

          {!isLoading && !isFail && (
            <button
              className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.5rem] px-[2rem] text-[1.3rem] w-full sm:w-auto"
              onClick={() => {
                dispatch(setIsMergePopupActive(false));
                navigate("/influencer/campaigns/upload", {
                  state: { campaign: participatedCampaignDetails },
                });
              }}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    )
  );
};

export default MergePopup;
